import Signin2 from "./Signin2";

export default function Signin() {
  return <Signin2 />;
}